import { render, staticRenderFns } from "./UpdateEmployeeLeavesDialog.vue?vue&type=template&id=c4f5b25c&"
import script from "./UpdateEmployeeLeavesDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateEmployeeLeavesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports